module.exports = __webpack_public_path__ + "img/STERiJECT_00_1.f96665b6.png";